// 🚨 AUTO-GENERADO desde InvoicePaymentDataType.ts - No editar manualmente

export const InvoicePaymentFormDataKeys = [
  "id",
  "descripcion",
  "monto",
  "vuelto",
  "formaPago",
  "digitosTarjeta",
  "numAprobacion",
  "estado",
  "exchangeRate",
  "created",
  "user",
  "recibeId",
  "recibe",
  "currencyId",
  "currency",
  "bankAccountId",
  "bankAccount",
  "creditOperatorId",
  "creditOperator",
  "invoiceId",
  "invoice"
] as const;
